import type { Category } from '~/stores/CategoriesStore';

import { ProductsCarouselWithBackground } from './shared/ProductsCarouselWithBackground';

interface ProductsCarouselSliderAllHitsProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  category: Category;
  priority?: boolean;
}

/**
 * Nominal ratios of the boxes this block occupies. Unlike its sibling with a
 * fixed `aspect-*`, the height here comes from the content (title, one row of
 * `ProductCardS`, the view-all button), so these are measured approximations
 * used only to derive how many pixels to request. `object-fit: cover` absorbs
 * the difference against the real box.
 */
const MOBILE_ASPECT_RATIO = 1;
const DESKTOP_ASPECT_RATIO = 1400 / 430;

const mobileClass = 'overflow-hidden rounded-6.5 bg-graphic-regular-brand p-4';
const carouselClass =
  'p-4 pb-8 bg-graphic-regular-brand overflow-hidden rounded-6.5';

export const ProductsCarouselSliderAllHits: React.FC<
  ProductsCarouselSliderAllHitsProps
> = (props) => (
  <ProductsCarouselWithBackground
    {...props}
    mobileAspectRatio={MOBILE_ASPECT_RATIO}
    desktopAspectRatio={DESKTOP_ASPECT_RATIO}
    mobileClassName={mobileClass}
    carouselClassName={carouselClass}
  />
);
